import { createSelector } from "reselect";

const selectCardsState = (state) => state.cards;

const selectCards = () => createSelector(selectCardsState, (cardsState) => cardsState.cards);
const selectCardsFilter = () => createSelector(selectCardsState, (cardsState) => cardsState.filter);


export {
    selectCards,
    selectCardsFilter
};
